// Idea:
//   - https://visly.app/blog/layout-isolated-components
//   - https://www.coryetzkorn.com/blog/dont-fear-empty-divs/
//   Basically, we could use spacing component in between components instead of using margin to achieve more flexibility
//   That is, spacing between components should not be tightly coupled of the context of using them individually

import React from "react";
import { BoxProps, useTheme } from "@mui/material";
import Box from "components/Box/Box";

type Props = BoxProps & {
  x?: number; // multiplier of theme.spacing
  y?: number; // multiplier of theme.spacing
  basis?: number; // multiplier of theme.spacing
};

const Spacer: React.FC<Props> = ({ x, y, basis, ...restProps }) => {
  const theme = useTheme();
  return (
    <Box
      data-testid="Spacer"
      width={x ? theme.spacing(x) : undefined}
      height={y ? theme.spacing(y) : undefined}
      flexBasis={basis ? theme.spacing(basis) : undefined}
      flexGrow={0}
      flexShrink={0}
      {...restProps}
    />
  );
};

export default Spacer;
